$(function() {
    const $serviceCenter = $('.js-service-center');
    let sliderCount = 1; 


    

    $serviceCenter.on('init', function(event, slick) {
        sliderCount = +slick.slideCount
        setSlideCount();
        setCurrentSlideNumber(slick.currentSlide)
    });

    $('[data-fancybox="service"] ').fancybox({
        beforeShow: function (instance, current) {
            current.opts.$orig.closest(".slick-initialized").slick('slickGoTo', parseInt(current.index))
        },
    });

    $serviceCenter.slick({
        slidesToShow: 1,
        prevArrow: $('.service-center__prev'),
        nextArrow: $('.service-center__next'),
        infinite: false,
    })

    

    $serviceCenter.on('beforeChange', function(event, slick, currnetSlide, nextSlide) {
        setCurrentSlideNumber(nextSlide)
    });

    function setSlideCount() {
        const $el = $('.js-service-center__count').find('.js-service-center__total');
        $el.text(sliderCount)
    }

    function setCurrentSlideNumber(currentSlide) {
        const $el = $('.js-service-center__count').find('.js-service-center__current');
        $el.text(currentSlide + 1 + ' /')
    }
});